import React from "react"

import { joinClasses, changeView, useClasses, strLenToFontSize } from "../globals";

import {
  Box,
  Button,
  Collapse,
  Divider,
  Paper,
  Typography
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"

// Assets

// Icons
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"

export const PasswordRecoveryComplete = ({ email }) => {
  const classes = useClasses()

  return (
    <React.Fragment>
      <Box
        className={joinClasses(
          classes._Padding,
          classes._Flex,
          classes._FlexDirectionColumn
        )}
      >
        <Box className={classes._Margin}>
          <Paper>
            <Box
              className={joinClasses(
                classes._Padding,
                classes._TextAlignCenter
              )}
              style={{ wordBreak: "break-word" }}
            >
              <Typography
                variant={`h${strLenToFontSize({
                  string: email,
                  baseLen: 20,
                  baseSize: 3,
                  minSize: 3,
                  maxSize: 6,
                  multiplier: -0.25
                })}`}
              >
                {email}
              </Typography>
            </Box>
          </Paper>
        </Box>
        <Box className={classes._Margin}>
          <Collapse in>
            <Alert severity="success">
              <Typography>
                We just sent a reset link to the above email.
                Please check your inbox and spam folders and follow the included instructions.
              </Typography>
            </Alert>
          </Collapse>
        </Box>
      </Box>

      <Divider />

      <Box className={classes._PaddingDouble}>
        <Button
          variant="text"
          fullWidth
          onClick={() => changeView("EmailPasswordLogin")}
          startIcon={<ChevronLeftIcon />}
        >
          Back to Sign in
        </Button>
      </Box>
    </React.Fragment>
  )
}

PasswordRecoveryComplete.title = "Password Recovery";